import React from 'react';

import { Tabs } from 'components/shared/Tabs';
import { Loading } from 'components/shared/Loading';
import { Button } from 'components/shared/Button';
import { Icon } from 'components/shared/Icon';

import { SchoolCard } from 'components/SchoolCard';
import { MainLayout } from 'components/Layout';
import { BreadcrumbsToolbar } from 'components/Toolbar';

import { getTranslation } from 'helpers/getTranslation';

import { getTabActions, getTabsItems } from './SchoolPage.helpers';

import styles from './SchoolPage.module.scss';

const SchoolPage = ({
  locale,
  loading,
  isRootAdmin,
  currentSchool,
  currentTab,
  onTabChange,
  onEditClick,
  onAddStudentContextItemClick,
  onAddAdminContextItemClick,
  onAddCourseContextItemClick,
  onAddTrainingContextItemClick,
  onAddArcadeContextItemClick,
  onGenerateCodeClick,
  onExportCodesClick,
  onExportActivationReportClick,
  onActivityReportClick,
  onCuratorReportClick,
  activationFrom,
  activationTo,
  schoolPrefix,
  onActivationFromChange,
  onActivationToChange,
  onSchoolPrefixChange,
}: {
  locale: any;
  loading: any;
  isRootAdmin: any;
  currentSchool: any;
  currentTab: any;
  onTabChange: any;
  onEditClick: any;
  onAddStudentContextItemClick: any;
  onAddAdminContextItemClick: any;
  onAddCourseContextItemClick: any;
  onAddTrainingContextItemClick: any;
  onAddArcadeContextItemClick: any;
  onGenerateCodeClick: any;
  onExportCodesClick: any;
  onExportActivationReportClick: any;
  onActivityReportClick: any;
  onCuratorReportClick: any;
  activationFrom: string;
  activationTo: string;
  schoolPrefix: string;
  onActivationFromChange: (value: string) => void;
  onActivationToChange: (value: string) => void;
  onSchoolPrefixChange: (value: string) => void;
}) => (
  <MainLayout
    toolbarComponent={
      isRootAdmin && (
        <BreadcrumbsToolbar
          breadcrumbsData={{
            schoolName: currentSchool?.name,
          }}
        />
      )
    }
  >
    {loading ? (
      <Loading />
    ) : (
      <>
        <SchoolCard
          {...currentSchool}
          locale={locale}
          withStatus={isRootAdmin}
          withEdit={isRootAdmin}
          onEditClick={onEditClick}
        />
        <div className={styles.curatorReportAction}>
          <Button
            size="md"
            variant="secondary"
            startIcon={<Icon name="dashboard" />}
            onClick={onCuratorReportClick}
          >
            {getTranslation('school_page.curator_report')}
          </Button>
        </div>
        <div className={styles.inner}>
          <Tabs
            className={styles.tabs}
            items={getTabsItems({
              isRootAdmin,
              activationFrom,
              activationTo,
              schoolPrefix,
              onActivationFromChange,
              onActivationToChange,
              onSchoolPrefixChange,
            })}
            actions={getTabActions({
              currentTab,
              isRootAdmin,
              onAddStudentContextItemClick,
              onAddAdminContextItemClick,
              onAddCourseContextItemClick,
              onAddArcadeContextItemClick,
              onAddTrainingContextItemClick,
              onGenerateCodeClick,
              onExportCodesClick,
              onExportActivationReportClick,
              onActivityReportClick,
            })}
            onTabChange={onTabChange}
          />
        </div>
      </>
    )}
  </MainLayout>
);

export default React.memo(SchoolPage) as any;
